//
//
//
//
//
//
//
//
//

import CdnImageMixin from "./CdnImageMixin";
import {formatDimension} from "../../helpers/format_helpers";
import AspectRatioBox from "../Layout/AspectRatioBox";
import Roundable from "../../mixins/Roundable";

export default {
    name: "CdnImage",
    components: {AspectRatioBox},
    mixins: [CdnImageMixin, Roundable],

    computed: {
        // The srcset string for the image for responsiveness
        imageSrcSet() {
            return this.imageSrcSets.length ? this.imageSrcSets.map(srcSet => `${srcSet.url} ${srcSet.width}w`).join(', ') : null;
        },

        srcProps() {
            if (this.immediate) {
                return {
                    src: this.imageSrc,
                    srcset: this.imageSrcSet,
                }
            }
            return {
                'data-src': this.imageSrc,
                'data-srcset': this.imageSrcSet,
            }
        },

        wrapperStyle() {
            return {
                maxWidth: '100%',
                width: this.cover || this.currentSize.width === '100vw' ? '100%' : formatDimension(this.currentDimensions.width),
                // Do not add min width for 'this.currentDimensions.width' as it might overflow max width
            }
        },

        imageStyle() {
            // We overwrite the native img tag width and height as these reflect the native image size but not the displayed size,
            // which would cause a wrong display of the image. However, the width and height attributes are required for a good Web Vitals score
            return {
                width: this.cover ? '100%' : 'auto',
                height: '100%'
            }
        }
    },

    methods: {
        setImageSourcesOnImageElement() {
            if (this.$refs.image) {
                this.$refs.image.src = this.imageSrc;
                this.$refs.image.srcset = this.imageSrcSet;
            }
        },
    }

}
